import { createApp } from 'vue'
import '@/assets/style/var.less'
// 千万不能改成less，不然tailwindcss不生效
import '@/assets/style/base.css'
import App from './App.vue'
import router, { setupRouter } from './router'
import { setupStore } from '../../../store'
import MateChat from '@matechat/core'
import '@devui-design/icons/icomoon/devui-icon.css'
import 'vant/es/toast/style'
import 'vant/lib/index.css'

async function bootstrap() {
  const app = createApp(App)
  setupStore(app)
  await setupRouter(app)
  // 路由准备就绪后挂载APP实例
  await router.isReady()

  app.use(MateChat).mount('#app')
}

void bootstrap()
